import React from 'react';
import Loadable from './components/Loadable';
import {
  ACTIVITIES_ROUTE,
  ADD_ORDER_CONFIG_CASH_HANDLING,
  ADD_ORDER_CONFIG_MID,
  ADD_ORDER_CONFIG_PAYMENT_METHOD,
  ADD_ORDER_CONFIG_PAYMENT_METHOD_V2,
  ADD_ORDER_CONFIG_SETTINGS,
  ADD_RESERVATION_ROUTE,
  ADMINS_ROUTE,
  ANALYTICS_ROUTE,
  BRANCH_ROUTE,
  BRANDS_ROUTE,
  BUSINESS_ROUTE,
  CAMPAIGN_ROUTE,
  CAMPAIGN_ROUTE_ADD,
  CUSTOMER_DETAIL_ROUTE,
  CUSTOMER_LIST_ROUTE,
  FEATURE_ACCESS_ROUTE,
  HOME_ROUTE,
  IMAGE_MANAGER_ROUTE,
  INTEGRATION_ROUTE,
  INTEGRATION_STATUS_ROUTE,
  INVENTORY_COMPOSITE_ITEMS_ROUTE,
  INVENTORY_DELIVERY_ORDERS_ROUTE,
  INVENTORY_DELIVERY_ORDER_DETAIL_ROUTE,
  INVENTORY_DELIVERY_ORDER_NEW_ROUTE,
  INVENTORY_INPUTS_ROUTE,
  INVENTORY_ITEM_SETUP_ROUTE,
  INVENTORY_PRODUCTION_RUNS_ROUTE,
  INVENTORY_PRODUCTION_RUN_DETAIL_ROUTE,
  INVENTORY_PRODUCTION_RUN_NEW_ROUTE,
  INVENTORY_PURCHASE_ORDERS_ROUTE,
  INVENTORY_PURCHASE_ORDER_DETAIL_ROUTE,
  INVENTORY_PURCHASE_ORDER_NEW_ROUTE,
  INVENTORY_REPORT_ROUTE,
  INVENTORY_ROUTE,
  INVENTORY_WASTE_ROUTE,
  INVENTORY_SETTINGS_ROUTE,
  INVENTORY_SUPPLIER_DATABASE_ROUTE,
  INVOICE_DETAIL_ROUTE,
  INVOICE_EXPANSION_ROUTE,
  INVOICE_NRR_DETAILS_ROUTE,
  INVOICE_NRR_NEW_ROUTE,
  INVOICE_ROUTE,
  KAI_V1_ROUTE,
  KAI_ADMIN_ROUTE,
  LANG_EXCEL_TO_JSON_ROUTE,
  LINKS_IN_BIO_ROUTE,
  ENGAGEIT_ROUTE,
  ENGAGEIT_INBOX_ROUTE,
  ENGAGEIT_ANALYTICS_ROUTE,
  ENGAGEIT_SETTINGS_VOICE_ROUTE,
  ENGAGEIT_SETTINGS_CHANNELS_ROUTE,
  ENGAGEIT_SETTINGS_PROMPTS_ROUTE,
  PIXEL_TRACKING_ROUTE,
  ESB_MENU_MAPPING_ROUTE,
  MIRROR_ORDER_ROUTE,
  PENDING_PAYMENT_ROUTE,
  LIVE_MONITOR_AUTO_READY_ROUTE,
  LIVE_MONITOR_AUTO_ACCEPT_ROUTE,
  LIVE_MONITOR_CATEGORY_OOS_LIST_ROUTE,
  LIVE_MONITOR_INTEGRATION_STATUS_ROUTE,
  LIVE_MONITOR_ITEM_OOS_LIST_ROUTE,
  LIVE_MONITOR_MENU_OOS_LIST_ROUTE,
  LIVE_MONITOR_PAUSED_STORES_ROUTE,
  LIVE_MONITOR_ROUTE,
  LOCATION_ROUTE,
  LOGIN_ROUTE,
  LOGOUT_ROUTE,
  LOYALTY_ROUTE,
  MENU_ITEMS_ROUTE,
  MENU_PULLING_ROUTE,
  MENU_ROUTE,
  MENU_V2_ROUTE,
  MODIFIERS_ROUTE,
  NEW_INVOICE_ROUTE,
  ONI_ROUTE,
  ORDER_AMENDER_ROUTE,
  PAYMENT_INTEGRATION_ROUTE,
  PERMISSION_ROUTE,
  PARTNER_ACCESS_ROUTE,
  API_ACTIVITY_LOG_ROUTE,
  PRINTER_PROFILES,
  PRINTER_SETTINGS_ROUTE,
  PROFILE_PASSWORD_CHANGE_ROUTE,
  PROFILE_TWO_FACTOR_ROUTE,
  PROFILE_ROUTE,
  PROMO_ROUTE,
  PROMO_ROUTE_ADD,
  PROMO_ROUTE_EDIT,
  PROVIDER_INTEGRATION_ROUTE,
  PROVIDER_ROUTE,
  QR_GENERATOR,
  RATING_REVIEW_INTEGRATION_ROUTE,
  RESERVATION_LOCATIONS_ROUTE,
  RESERVATION_ROUTE,
  RESERVATION_SETTINGS_ROUTE,
  ROLE_ROUTE,
  RULES_ROUTE,
  STRIPE_PAYMENT_INTEGRATION_ROUTE,
  USERS_ROUTE,
  WEBHOOKS_ROUTE,
  WEBHOOK_REPLAY_ROUTE,
  WEBSHOP_BRAND_CUSTOMIZATION_ROUTE,
  WEBSHOP_BRAND_CUSTOMIZATION_ROUTE_V2,
  WEBSHOP_DELIVERY_SHUTDOWN_ROUTE,
  WEBSHOP_FOODHALL_ROUTE,
  WEBSHOP_NOTICE_ROUTE,
  WEBSHOP_PAYMENT_SETTINGS_ROUTE,
  WEBSHOP_ROUTE,
  WHITELABEL_ROUTE,
} from './config/constants/routes';

import NativeAnalytics from './containers/NativeAnalytics';
import OrderAmender from './containers/OrderAmender';
import PrinterProfiles from './containers/PrinterProfiles';
import { lazyWithRetry } from './utils/lazyWithRetry';
import { PERMISSIONS } from './utils/permission';

const Login = Loadable(lazyWithRetry(() => import('./containers/Auth')));
const Branch = Loadable(lazyWithRetry(() => import('./containers/Branch')));
const PartnerIntegration = Loadable(
  lazyWithRetry(() => import('./containers/Branch/PartnerIntegration')),
);
const Brand = Loadable(lazyWithRetry(() => import('./containers/Brand')));
const Business = Loadable(lazyWithRetry(() => import('./containers/Business')));

// Integration is now hidden from the routes
// const Integration = Loadable(
//   lazyWithRetry(() => import('./containers/Integration')),
// );

const IntegrationStatus = Loadable(
  lazyWithRetry(() => import('./containers/IntegrationStatus')),
);
const BrandListByLocation = Loadable(
  lazyWithRetry(() => import('./containers/Integration/BrandListByLocation')),
);
const ProviderList = Loadable(
  lazyWithRetry(() => import('./containers/Integration/ProviderList')),
);
const ProviderIntegrationList = Loadable(
  lazyWithRetry(() => import('./containers/ProviderIntegration')),
);
const Logout = Loadable(lazyWithRetry(() => import('./containers/Logout')));
const Menu = Loadable(lazyWithRetry(() => import('./containers/Menu')));
const ONI = Loadable(lazyWithRetry(() => import('./containers/ONI')));
const OrderDetails = Loadable(
  lazyWithRetry(() => import('./containers/ONI/OrderDetails')),
);
const Permission = Loadable(
  lazyWithRetry(() => import('./containers/Permission')),
);
const PartnerAccess = Loadable(
  lazyWithRetry(() => import('./containers/PartnerAccess')),
);
const ApiActivityLog = Loadable(
  lazyWithRetry(() => import('./containers/ApiActivityLog')),
);
const Profile = Loadable(lazyWithRetry(() => import('./containers/Profile')));
const ChangePassword = Loadable(
  lazyWithRetry(() => import('./containers/Profile/ChangePassword')),
);
const TwoFactor = Loadable(
  lazyWithRetry(() => import('./containers/Profile/TwoFactor')),
);
const Role = Loadable(lazyWithRetry(() => import('./containers/Role')));
const Webhooks = Loadable(lazyWithRetry(() => import('./containers/Webhooks')));
const WebhookReplay = Loadable(
  lazyWithRetry(() => import('./containers/WebhookReplay')),
);
const User = Loadable(lazyWithRetry(() => import('./containers/User')));
const Customer = Loadable(
  lazyWithRetry(() => import('./containers/Customer/List')),
);
const CustomerDetail = Loadable(
  lazyWithRetry(() => import('./containers/Customer/Detail')),
);
const Activities = Loadable(
  lazyWithRetry(() => import('./containers/ActivityLog')),
);
const LangExcelToJSON = Loadable(
  lazyWithRetry(() => import('./containers/LangExcelToJSON')),
);

const QRGenerator = Loadable(
  lazyWithRetry(() => import('./containers/QRGenerator')),
);

const PrinterSettings = Loadable(
  lazyWithRetry(() => import('./containers/PrinterSettings')),
);
const MenuV2 = Loadable(lazyWithRetry(() => import('./containers/MenuV2')));

const Webshop = Loadable(lazyWithRetry(() => import('./containers/Webshop')));
const Promo = Loadable(lazyWithRetry(() => import('./containers/Promo')));
const PromoAdd = Loadable(
  lazyWithRetry(() => import('./containers/Promo/PromoAddEdit')),
);
const Loyalty = Loadable(lazyWithRetry(() => import('./containers/Loyalty')));

const LinkInBio = Loadable(
  lazyWithRetry(() => import('./containers/LinkInBio')),
);

const Reservation = Loadable(
  lazyWithRetry(() => import('./containers/Reservation')),
);

const AddReservation = Loadable(
  lazyWithRetry(() => import('./containers/Reservation/AddReservation')),
);

const Whitelabel = Loadable(
  lazyWithRetry(() => import('./containers/Whitelabel')),
);

const ImageManager = Loadable(
  lazyWithRetry(() => import('./containers/ImageManager')),
);

const PaymentIntegration = Loadable(
  lazyWithRetry(() => import('./containers/PaymentIntegration')),
);

const RatingAndReview = Loadable(
  lazyWithRetry(() => import('./containers/RatingAndReview')),
);

const LiveMonitor = Loadable(
  lazyWithRetry(() => import('./containers/LiveMonitor')),
);

const LiveMonitorPausedStores = Loadable(
  lazyWithRetry(() =>
    import('./containers/LiveMonitor/PauseStores/PausedStoreListDetails'),
  ),
);

const LiveMonitorIntegrationStatus = Loadable(
  lazyWithRetry(() =>
    import(
      './containers/LiveMonitor/IntegrationStatus/IntegrationStatusListDetails'
    ),
  ),
);

const AutoReadyActivityList = Loadable(
  lazyWithRetry(() =>
    import(
      './containers/LiveMonitor/AutoReadyActivity/AutoReadyActivityDetails'
    ),
  ),
);

const AutoAcceptActivityList = Loadable(
  lazyWithRetry(() =>
    import(
      './containers/LiveMonitor/AutoAcceptActivity/AutoAcceptActivityDetails'
    ),
  ),
);

const Campaign = Loadable(lazyWithRetry(() => import('./containers/Campaign')));
const CampaignDetails = Loadable(
  lazyWithRetry(() =>
    import('./containers/Campaign/components/CampaignDetails'),
  ),
);
const CampaignForm = Loadable(
  lazyWithRetry(() => import('./containers/Campaign/components/CampaignForm')),
);
const LiveMonitorMenuOOSActivity = Loadable(
  lazyWithRetry(() =>
    import('./containers/LiveMonitor/OOSActivity/MenuOOSList'),
  ),
);
const LiveMonitorCategoryOOSActivity = Loadable(
  lazyWithRetry(() =>
    import('./containers/LiveMonitor/OOSActivity/CategoryOOSList'),
  ),
);
const LiveMonitorItemOOSActivity = Loadable(
  lazyWithRetry(() =>
    import('./containers/LiveMonitor/OOSActivity/ItemOOSList'),
  ),
);
const FeatureAccess = Loadable(
  lazyWithRetry(() => import('./containers/FeatureAccess')),
);
const AddOrderConfig = Loadable(
  lazyWithRetry(() => import('./containers/AddOrderConfig')),
);

const MenuPulling = Loadable(
  lazyWithRetry(() => import('./containers/MenuPulling')),
);

const Billing = Loadable(lazyWithRetry(() => import('./containers/Billing')));

const InvoiceDetails = Loadable(
  lazyWithRetry(() => import('./containers/Billing/Invoice/Details')),
);

const NRRInvoice = Loadable(
  lazyWithRetry(() => import('./containers/Billing/NRRInvoice')),
);

const InventoryReport = Loadable(
  lazyWithRetry(() => import('./containers/Inventory/Report')),
);

const InventoryItemSetup = Loadable(
  lazyWithRetry(() => import('./containers/Inventory/ItemSetup')),
);

const InventoryCompositeItems = Loadable(
  lazyWithRetry(() => import('./containers/Inventory/CompositeItems')),
);

const InventoryInputs = Loadable(
  lazyWithRetry(() => import('./containers/Inventory/Inputs')),
);

const InventorySupplierDatabase = Loadable(
  lazyWithRetry(() => import('./containers/Inventory/SupplierDatabase')),
);

const InventoryOverview = Loadable(
  lazyWithRetry(() => import('./containers/Inventory/Overview')),
);

const InventorySettings = Loadable(
  lazyWithRetry(() => import('./containers/Inventory/Settings')),
);

const InventoryPurchaseOrders = Loadable(
  lazyWithRetry(() => import('./containers/Inventory/PurchaseOrders')),
);

const InventoryPurchaseOrderDetail = Loadable(
  lazyWithRetry(() => import('./containers/Inventory/PurchaseOrders/Detail')),
);

const InventoryPurchaseOrderNew = Loadable(
  lazyWithRetry(() =>
    import('./containers/Inventory/PurchaseOrders/CreateForm'),
  ),
);

const InventoryDeliveryOrders = Loadable(
  lazyWithRetry(() => import('./containers/Inventory/DeliveryOrders')),
);

const InventoryDeliveryOrderDetail = Loadable(
  lazyWithRetry(() => import('./containers/Inventory/DeliveryOrders/Detail')),
);

const InventoryDeliveryOrderNew = Loadable(
  lazyWithRetry(() =>
    import('./containers/Inventory/DeliveryOrders/CreateForm'),
  ),
);

const InventoryWaste = Loadable(
  lazyWithRetry(() => import('./containers/Inventory/Waste')),
);

const InventoryProductionRuns = Loadable(
  lazyWithRetry(() => import('./containers/Inventory/ProductionRuns')),
);

const InventoryProductionRunDetail = Loadable(
  lazyWithRetry(() => import('./containers/Inventory/ProductionRuns/Detail')),
);

const InventoryProductionRunNew = Loadable(
  lazyWithRetry(() =>
    import('./containers/Inventory/ProductionRuns/CreateForm'),
  ),
);

const Kai = Loadable(lazyWithRetry(() => import('./containers/Kai')));
const KaiAdmin = Loadable(lazyWithRetry(() => import('./containers/KaiAdmin')));
const Location = Loadable(lazyWithRetry(() => import('./containers/Location')));
const ESBMenuMapping = Loadable(
  lazyWithRetry(() => import('./containers/ESBMenuMapping')),
);
const MirrorOrder = Loadable(
  lazyWithRetry(() => import('./containers/MirrorOrder')),
);
const PendingPayment = Loadable(
  lazyWithRetry(() => import('./containers/PendingPayment')),
);

const EngageIt = Loadable(lazyWithRetry(() => import('./containers/EngageIt')));

const PixelTracking = Loadable(
  lazyWithRetry(() => import('./containers/PixelTracking')),
);

const routes = [
  {
    path: LOGIN_ROUTE,
    main: () => <Login />,
  },
  {
    path: HOME_ROUTE,
    exact: true,
    main: () => <Business />,
  },
  {
    path: LOGOUT_ROUTE,
    main: () => <Logout />,
  },
  {
    path: BUSINESS_ROUTE,
    main: () => <Business />,
  },
  {
    path: BRANDS_ROUTE,
    main: () => <Brand />,
  },
  {
    exact: true,
    path: BRANCH_ROUTE,
    main: () => <Branch />,
  },
  {
    path: USERS_ROUTE,
    main: () => <User />,
  },
  {
    path: ADMINS_ROUTE,
    main: () => <User />,
  },
  {
    path: PERMISSION_ROUTE,
    main: () => <Permission />,
  },
  {
    path: PARTNER_ACCESS_ROUTE,
    main: () => <PartnerAccess />,
  },
  {
    path: API_ACTIVITY_LOG_ROUTE,
    main: () => <ApiActivityLog />,
  },
  {
    path: ROLE_ROUTE,
    main: () => <Role />,
  },
  // Currently Integration Page is hidden
  // {
  //   path: '/integration',
  //   exact: true,
  //   main: () => <Integration />,
  // },
  {
    path: ACTIVITIES_ROUTE,
    exact: true,
    main: () => <Activities />,
  },
  {
    path: WEBHOOKS_ROUTE,
    exact: true,
    main: () => <Webhooks />,
  },
  {
    path: WEBHOOK_REPLAY_ROUTE,
    exact: true,
    main: () => <WebhookReplay />,
    permission: PERMISSIONS.FETCH_WEBHOOK_REPLAY,
  },
  {
    path: INTEGRATION_STATUS_ROUTE,
    exact: true,
    main: () => <IntegrationStatus />,
  },
  {
    path: `${INTEGRATION_ROUTE}/:bizId/:locId`,
    exact: true,
    main: () => <BrandListByLocation />,
  },
  {
    path: MENU_ROUTE,
    main: () => <Menu />,
  },
  {
    path: MENU_ITEMS_ROUTE,
    main: () => <Menu />,
  },
  {
    path: MODIFIERS_ROUTE,
    main: () => <Menu />,
  },
  {
    path: RULES_ROUTE,
    main: () => <Menu />,
  },
  {
    exact: true,
    path: PROFILE_ROUTE,
    main: () => <Profile />,
  },
  {
    path: `${INTEGRATION_ROUTE}/:branchId/:brandId/:providerId/partner-integration`,
    main: () => <PartnerIntegration />,
  },
  {
    path: PROVIDER_ROUTE,
    exact: true,
    main: () => <ProviderList />,
  },
  {
    path: `${PROVIDER_ROUTE}/:businessId/:branchId/:brandId`,
    exact: true,
    main: () => <ProviderList />,
  },
  {
    path: PROVIDER_INTEGRATION_ROUTE,
    exact: true,
    main: () => <ProviderIntegrationList />,
  },
  {
    exact: true,
    path: PROFILE_PASSWORD_CHANGE_ROUTE,
    main: () => <ChangePassword />,
  },
  {
    exact: true,
    path: PROFILE_TWO_FACTOR_ROUTE,
    main: () => <TwoFactor />,
  },
  {
    path: ONI_ROUTE,
    exact: true,
    main: () => <ONI />,
    permission: 'fetch.oni',
  },
  // {
  //   path: '/past-orders',
  //   exact: true,
  //   main: () => <ONI />,
  // },
  // {
  //   path: '/past-orders/:id',
  //   exact: true,
  //   main: () => <OrderDetails />,
  // },
  {
    path: `${ONI_ROUTE}/:id`,
    exact: true,
    main: () => <OrderDetails />,
    permission: 'fetch.oni',
  },
  {
    path: LANG_EXCEL_TO_JSON_ROUTE,
    exact: true,
    main: () => <LangExcelToJSON />,
  },
  {
    path: QR_GENERATOR,
    exact: true,
    main: () => <QRGenerator />,
  },
  {
    path: ANALYTICS_ROUTE,
    main: () => <NativeAnalytics />,
    permission: 'fetch.native.analytics',
  },
  {
    path: PRINTER_SETTINGS_ROUTE,
    exact: true,
    main: () => <PrinterSettings />,
  },
  {
    path: WEBSHOP_ROUTE,
    exact: true,
    main: () => <Webshop />,
  },
  {
    path: WEBSHOP_BRAND_CUSTOMIZATION_ROUTE_V2,
    exact: true,
    main: () => <Webshop />,
  },
  {
    path: WEBSHOP_BRAND_CUSTOMIZATION_ROUTE,
    exact: true,
    main: () => <Webshop />,
  },
  {
    path: WEBSHOP_FOODHALL_ROUTE,
    exact: true,
    main: () => <Webshop />,
  },
  {
    path: WEBSHOP_PAYMENT_SETTINGS_ROUTE,
    exact: true,
    main: () => <Webshop />,
  },
  {
    path: WEBSHOP_NOTICE_ROUTE,
    exact: true,
    main: () => <Webshop />,
  },
  {
    path: WEBSHOP_DELIVERY_SHUTDOWN_ROUTE,
    exact: true,
    main: () => <Webshop />,
  },
  {
    path: MENU_V2_ROUTE,
    main: () => <MenuV2 />,
  },
  {
    path: LINKS_IN_BIO_ROUTE,
    exact: true,
    main: () => <LinkInBio />,
  },
  {
    path: PROMO_ROUTE,
    exact: true,
    main: () => <Promo />,
  },
  {
    path: LOYALTY_ROUTE,
    exact: true,
    main: () => <Loyalty />,
    permission: 'fetch.loyalty',
  },
  {
    path: PROMO_ROUTE_ADD,
    exact: true,
    main: () => <PromoAdd />,
  },
  {
    path: `${PROMO_ROUTE_EDIT}/:id`,
    exact: true,
    main: () => <PromoAdd />,
  },
  {
    path: RESERVATION_ROUTE,
    exact: true,
    main: () => <Reservation />,
  },
  {
    path: ADD_RESERVATION_ROUTE,
    exact: true,
    main: () => <AddReservation />,
  },
  {
    path: RESERVATION_SETTINGS_ROUTE,
    exact: true,
    main: () => <Reservation />,
  },
  {
    path: RESERVATION_LOCATIONS_ROUTE,
    exact: true,
    main: () => <Reservation />,
  },
  {
    path: WHITELABEL_ROUTE,
    exact: true,
    main: () => <Whitelabel />,
  },
  {
    path: IMAGE_MANAGER_ROUTE,
    exact: true,
    main: () => <ImageManager />,
  },
  {
    path: PAYMENT_INTEGRATION_ROUTE,
    exact: true,
    main: () => <PaymentIntegration />,
  },
  {
    path: STRIPE_PAYMENT_INTEGRATION_ROUTE,
    exact: true,
    main: () => <PaymentIntegration />,
  },
  {
    path: RATING_REVIEW_INTEGRATION_ROUTE,
    exact: true,
    main: () => <RatingAndReview />,
    permission: 'fetch.review.integration',
  },
  {
    path: LIVE_MONITOR_ROUTE,
    exact: true,
    main: () => <LiveMonitor />,
    permission: PERMISSIONS.FETCH_LIVE_MONITOR,
  },
  {
    path: LIVE_MONITOR_PAUSED_STORES_ROUTE,
    exact: true,
    main: () => <LiveMonitorPausedStores />,
    permission: PERMISSIONS.FETCH_LIVE_MONITOR,
  },
  {
    path: LIVE_MONITOR_INTEGRATION_STATUS_ROUTE,
    exact: true,
    main: () => <LiveMonitorIntegrationStatus />,
    permission: PERMISSIONS.FETCH_LIVE_MONITOR,
  },
  {
    path: LIVE_MONITOR_AUTO_READY_ROUTE,
    exact: true,
    main: () => <AutoReadyActivityList />,
    permission: PERMISSIONS.FETCH_LIVE_MONITOR,
  },
  {
    path: LIVE_MONITOR_AUTO_ACCEPT_ROUTE,
    exact: true,
    main: () => <AutoAcceptActivityList />,
    permission: PERMISSIONS.FETCH_LIVE_MONITOR,
  },
  {
    path: CAMPAIGN_ROUTE,
    exact: true,
    main: () => <Campaign />,
    permission: PERMISSIONS.FETCH_CAMPAIGN,
  },
  {
    path: `${CAMPAIGN_ROUTE}/:id`,
    exact: true,
    main: () => <CampaignDetails />,
    permission: PERMISSIONS.FETCH_CAMPAIGN,
  },
  {
    path: CAMPAIGN_ROUTE_ADD,
    exact: true,
    main: () => <CampaignForm />,
    permission: PERMISSIONS.CREATE_CAMPAIGN,
  },
  {
    path: LIVE_MONITOR_MENU_OOS_LIST_ROUTE,
    exact: true,
    main: () => <LiveMonitorMenuOOSActivity />,
    permission: PERMISSIONS.FETCH_LIVE_MONITOR,
  },
  {
    path: LIVE_MONITOR_CATEGORY_OOS_LIST_ROUTE,
    exact: true,
    main: () => <LiveMonitorCategoryOOSActivity />,
    permission: PERMISSIONS.FETCH_LIVE_MONITOR,
  },
  {
    path: LIVE_MONITOR_ITEM_OOS_LIST_ROUTE,
    exact: true,
    main: () => <LiveMonitorItemOOSActivity />,
    permission: PERMISSIONS.FETCH_LIVE_MONITOR,
  },
  {
    path: FEATURE_ACCESS_ROUTE,
    exact: true,
    main: () => <FeatureAccess />,
    permission: PERMISSIONS.FETCH_FEATURE_ALL,
  },
  {
    path: ADD_ORDER_CONFIG_PAYMENT_METHOD,
    exact: true,
    main: () => <AddOrderConfig />,
  },
  {
    path: ADD_ORDER_CONFIG_PAYMENT_METHOD_V2,
    exact: true,
    main: () => <AddOrderConfig />,
  },
  {
    path: ADD_ORDER_CONFIG_SETTINGS,
    exact: true,
    main: () => <AddOrderConfig />,
  },
  {
    path: ADD_ORDER_CONFIG_CASH_HANDLING,
    exact: true,
    main: () => <AddOrderConfig />,
  },
  {
    path: ADD_ORDER_CONFIG_MID,
    exact: true,
    main: () => <AddOrderConfig />,
  },
  {
    path: MENU_PULLING_ROUTE,
    exact: true,
    main: () => <MenuPulling />,
    permission: PERMISSIONS.FETCH_MENU_PULLING,
  },
  {
    path: CUSTOMER_LIST_ROUTE,
    exact: true,
    main: () => <Customer />,
    permission: PERMISSIONS.FETCH_CRM_ALL,
  },
  {
    path: CUSTOMER_DETAIL_ROUTE,
    exact: true,
    main: () => <CustomerDetail />,
    permission: PERMISSIONS.FETCH_CRM_ALL,
  },
  {
    path: INVOICE_ROUTE,
    exact: true,
    main: () => <Billing />,
    permission: PERMISSIONS.FETCH_INVOICE,
  },
  {
    path: NEW_INVOICE_ROUTE,
    exact: true,
    main: () => <InvoiceDetails />,
    permission: PERMISSIONS.FETCH_INVOICE,
  },
  {
    path: INVOICE_EXPANSION_ROUTE,
    exact: true,
    main: () => <InvoiceDetails />,
    permission: PERMISSIONS.FETCH_INVOICE,
  },
  {
    path: INVOICE_NRR_NEW_ROUTE,
    exact: true,
    main: () => <NRRInvoice />,
    permission: PERMISSIONS.FETCH_INVOICE,
  },
  {
    path: INVOICE_NRR_DETAILS_ROUTE,
    exact: true,
    main: () => <NRRInvoice />,
    permission: PERMISSIONS.FETCH_INVOICE,
  },
  {
    path: INVOICE_DETAIL_ROUTE,
    exact: true,
    main: () => <InvoiceDetails />,
    permission: PERMISSIONS.FETCH_INVOICE,
  },
  {
    path: INVENTORY_REPORT_ROUTE,
    exact: true,
    main: () => <InventoryReport />,
  },
  {
    path: INVENTORY_ITEM_SETUP_ROUTE,
    exact: true,
    main: () => <InventoryItemSetup />,
  },
  {
    path: INVENTORY_COMPOSITE_ITEMS_ROUTE,
    exact: true,
    main: () => <InventoryCompositeItems />,
  },
  {
    path: INVENTORY_INPUTS_ROUTE,
    exact: true,
    main: () => <InventoryInputs />,
  },
  {
    path: INVENTORY_SUPPLIER_DATABASE_ROUTE,
    exact: true,
    main: () => <InventorySupplierDatabase />,
  },
  {
    path: INVENTORY_ROUTE,
    exact: true,
    main: () => <InventoryOverview />,
  },
  {
    path: INVENTORY_SETTINGS_ROUTE,
    exact: true,
    main: () => <InventorySettings />,
  },
  {
    path: INVENTORY_PURCHASE_ORDER_NEW_ROUTE,
    exact: true,
    main: () => <InventoryPurchaseOrderNew />,
  },
  {
    path: INVENTORY_PURCHASE_ORDER_DETAIL_ROUTE,
    exact: true,
    main: () => <InventoryPurchaseOrderDetail />,
  },
  {
    path: INVENTORY_PURCHASE_ORDERS_ROUTE,
    exact: true,
    main: () => <InventoryPurchaseOrders />,
  },
  {
    path: INVENTORY_DELIVERY_ORDER_NEW_ROUTE,
    exact: true,
    main: () => <InventoryDeliveryOrderNew />,
  },
  {
    path: INVENTORY_DELIVERY_ORDER_DETAIL_ROUTE,
    exact: true,
    main: () => <InventoryDeliveryOrderDetail />,
  },
  {
    path: INVENTORY_DELIVERY_ORDERS_ROUTE,
    exact: true,
    main: () => <InventoryDeliveryOrders />,
  },
  {
    path: INVENTORY_WASTE_ROUTE,
    exact: true,
    main: () => <InventoryWaste />,
  },
  {
    path: INVENTORY_PRODUCTION_RUN_NEW_ROUTE,
    exact: true,
    main: () => <InventoryProductionRunNew />,
  },
  {
    path: INVENTORY_PRODUCTION_RUN_DETAIL_ROUTE,
    exact: true,
    main: () => <InventoryProductionRunDetail />,
  },
  {
    path: INVENTORY_PRODUCTION_RUNS_ROUTE,
    exact: true,
    main: () => <InventoryProductionRuns />,
  },
  {
    path: ORDER_AMENDER_ROUTE,
    exact: true,
    main: () => <OrderAmender />,
  },
  {
    path: PRINTER_PROFILES,
    exact: true,
    main: () => <PrinterProfiles />,
  },
  {
    path: KAI_V1_ROUTE,
    exact: true,
    main: () => <Kai />,
  },
  {
    path: KAI_ADMIN_ROUTE,
    exact: true,
    main: () => <KaiAdmin />,
  },
  {
    path: LOCATION_ROUTE,
    exact: true,
    main: () => <Location />,
  },
  {
    path: ESB_MENU_MAPPING_ROUTE,
    exact: true,
    main: () => <ESBMenuMapping />,
  },
  {
    path: MIRROR_ORDER_ROUTE,
    exact: true,
    main: () => <MirrorOrder />,
  },
  {
    path: PENDING_PAYMENT_ROUTE,
    exact: true,
    main: () => <PendingPayment />,
  },
  {
    path: ENGAGEIT_ROUTE,
    exact: true,
    main: () => <EngageIt />,
    permission: PERMISSIONS.FETCH_ENGAGEIT,
  },
  {
    path: ENGAGEIT_INBOX_ROUTE,
    exact: true,
    main: () => <EngageIt />,
    permission: PERMISSIONS.FETCH_ENGAGEIT,
  },
  {
    path: ENGAGEIT_ANALYTICS_ROUTE,
    exact: true,
    main: () => <EngageIt />,
    permission: PERMISSIONS.FETCH_ENGAGEIT,
  },
  {
    path: ENGAGEIT_SETTINGS_VOICE_ROUTE,
    exact: true,
    main: () => <EngageIt />,
    permission: PERMISSIONS.FETCH_ENGAGEIT,
  },
  {
    path: ENGAGEIT_SETTINGS_CHANNELS_ROUTE,
    exact: true,
    main: () => <EngageIt />,
    permission: PERMISSIONS.FETCH_ENGAGEIT,
  },
  {
    path: ENGAGEIT_SETTINGS_PROMPTS_ROUTE,
    exact: true,
    main: () => <EngageIt />,
    permission: PERMISSIONS.FETCH_ENGAGEIT,
  },
  {
    path: PIXEL_TRACKING_ROUTE,
    exact: true,
    main: () => <PixelTracking />,
    permission: PERMISSIONS.FETCH_PIXEL_TRACKING,
  },
];
export default routes;
